<template>
    <div class="myphone-sale">
        <div v-show="loading" style="text-align: center; padding: 25px 0; padding-bottom: 0;">
            <inline-loader></inline-loader>
        </div>
        <v-container grid-list-md fluid>
            <div class="myphone-sale__swiper">
                <div class="swiper-wrapper">
                    <div class="swiper-slide">
                        <div class="product-item">
                            <div class="product-item__content">
                                <div class="product-item__img">
                                    <!-- <img class="img-fluid" :src="product.primary_image" alt=""> -->
                                    <v-img src="https://digima.sgp1.digitaloceanspaces.com/mybarko/cover-photo-user.jpg"
                                        lazy-src="https://digima.sgp1.digitaloceanspaces.com/mybarko/item-placeholder.svg"
                                        contain height="150"></v-img>
                                    <sale-tag>
                                        <div class="percent">50%</div>
                                        <div class="off">OFF</div>
                                    </sale-tag>
                                    <my-phone-shop-tag>
                                        myphone | SHOP
                                    </my-phone-shop-tag>
                                </div>
                                <div class="product-item__bottom">
                                    <div class="product-item__details">
                                        <div class="product-item__details-name substr">HELLO WORLD</div>
                                        <div class="product-item__details-price">
                                            <div class="sale">10.50</div>
                                            <div class="prev-price">P 50.00</div>
                                        </div>
                                    </div>
                                    <div class="product-item__rating mb-1">
                                        <heart></heart>
                                        <rating-star></rating-star>
                                    </div>
                                    <v-btn depressed dark small class="text-capitalize" color="#f9690e">Buy Now</v-btn>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="swiper-slide">
                        <div class="product-item">
                            <div class="product-item__content">
                                <div class="product-item__img">
                                    <!-- <img class="img-fluid" :src="product.primary_image" alt=""> -->
                                    <v-img src="https://digima.sgp1.digitaloceanspaces.com/mybarko/cover-photo-user.jpg"
                                        lazy-src="https://digima.sgp1.digitaloceanspaces.com/mybarko/item-placeholder.svg"
                                        contain height="150"></v-img>
                                    <sale-tag>
                                        <div class="percent">50%</div>
                                        <div class="off">OFF</div>
                                    </sale-tag>
                                    <my-phone-shop-tag>
                                        myphone | SHOP
                                    </my-phone-shop-tag>
                                </div>
                                <div class="product-item__bottom">
                                    <div class="product-item__details">
                                        <div class="product-item__details-name substr">HELLO WORLD</div>
                                        <div class="product-item__details-price">
                                            <div class="sale">10.50</div>
                                            <div class="prev-price">P 50.00</div>
                                        </div>
                                    </div>
                                    <div class="product-item__rating mb-1">
                                        <heart></heart>
                                        <rating-star></rating-star>
                                    </div>
                                    <v-btn depressed dark small class="text-capitalize" color="#f9690e">Buy Now</v-btn>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="swiper-slide">
                        <div class="product-item">
                            <div class="product-item__content">
                                <div class="product-item__img">
                                    <!-- <img class="img-fluid" :src="product.primary_image" alt=""> -->
                                    <v-img src="https://digima.sgp1.digitaloceanspaces.com/mybarko/cover-photo-user.jpg"
                                        lazy-src="https://digima.sgp1.digitaloceanspaces.com/mybarko/item-placeholder.svg"
                                        contain height="150"></v-img>
                                    <sale-tag>
                                        <div class="percent">50%</div>
                                        <div class="off">OFF</div>
                                    </sale-tag>
                                    <my-phone-shop-tag>
                                        myphone | SHOP
                                    </my-phone-shop-tag>
                                </div>
                                <div class="product-item__bottom">
                                    <div class="product-item__details">
                                        <div class="product-item__details-name substr">HELLO WORLD</div>
                                        <div class="product-item__details-price">
                                            <div class="sale">10.50</div>
                                            <div class="prev-price">P 50.00</div>
                                        </div>
                                    </div>
                                    <div class="product-item__rating mb-1">
                                        <heart></heart>
                                        <rating-star></rating-star>
                                    </div>
                                    <v-btn depressed dark small class="text-capitalize" color="#f9690e">Buy Now</v-btn>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </v-container>
    </div>
</template>

<script>
    import Swiper from "swiper";
    import BaseClass from "../BaseClass";
    export default {
        extends: BaseClass,
        data() {
            return {
                loading: false,
            }
        },
        mounted() {
            var swiper = new Swiper(".myphone-sale__swiper", {
                slidesPerView: 2,
                spaceBetween: 16,
                freeMode: true,
                autoplay: {
                    delay: 2500,
                    disableOnInteraction: false,
                },
                pagination: {
                    el: '.swiper-pagination',
                }
            });

        },
    }
</script>

<style lang="scss">
    @import "../scss/app.scss";

    .myphone-sale {
        background-color: #1caef2;

        .myphone-sale__swiper {
            position: relative;
            overflow: hidden;

            .product-item {
                .product-item__content {
                    background-color: #fff;

                    .product-item__img {
                        background-color: #fff;
                        border: 1px solid #f9690e;
                    }

                    .product-item__bottom {
                        border-top: none;
                        border: 1px solid #f9690e;
                        padding: 5px 5px 8px;
                        .product-item__details-price
                        {
                            display: grid;
                            grid-template-columns: repeat(2, 1fr);
                            grid-column-gap: 10px;
                            .prev-price
                            {
                                justify-self: end;
                            }
                        }
                        .v-btn
                        {
                            margin: 0px;
                            width: 135px;
                        }
                    }
                }
            }
        }

        .swiper-button-next,
        .swiper-button-prev {
            width: 33px;
            height: 33px;
            z-index: 1;
        }

        .swiper-button-next {
            right: -10px;
            background-image: url('../assets/svgs/next.svg');
            -webkit-box-shadow: 0px 0px 15px 2px rgba(0, 0, 0, 0.4);
            -moz-box-shadow: 0px 0px 15px 2px rgba(0, 0, 0, 0.4);
            box-shadow: 0px 0px 15px 2px rgba(0, 0, 0, 0.4);
            background-color: #fff;
            border-radius: 100%;
        }

        .swiper-button-prev {
            left: -10px;
            background-image: url('../assets/svgs/prev.svg');
            -webkit-box-shadow: 0px 0px 15px 2px rgba(0, 0, 0, 0.4);
            -moz-box-shadow: 0px 0px 15px 2px rgba(0, 0, 0, 0.4);
            box-shadow: 0px 0px 15px 2px rgba(0, 0, 0, 0.4);
            background-color: #fff;
            border-radius: 100%;
        }
    }
</style>